import { type QueryKey } from '@tanstack/react-query';
import {
  type Language,
  mapSearchListingsFiltersToSearchFilterRequest,
  type SearchListingsFilters,
  type SearchListingsOptions,
} from '@ev-tech/search-modules-api';

export const LISTINGS_QUERY_KEY = 'listings';
export const GLOBAL_LISTINGS_QUERY_KEY = 'global-listings';
export const GEO_COORDINATES_QUERY_KEY = 'geo-coordinates';
export const PLACE_DETAILS_QUERY_KEY = 'place-details';
export const AGENT_PROFILE_QUERY_KEY = 'agent-profile';
export const SHOP_QUERY_KEY = 'shop';
export const SHOPS_QUERY_KEY = 'shops';
export const WATCHLIST_QUERY_KEY = 'watchlist';
export const AI_SEARCH_QUERY_KEY = 'ai-search';
export const AUTOSUGGESTION_QUERY_KEY = 'autosuggestion';

export const getListingsQueryKey = ({ filters, options }: { filters: SearchListingsFilters; options: SearchListingsOptions }) => [
  LISTINGS_QUERY_KEY,
  { filters: mapSearchListingsFiltersToSearchFilterRequest(filters, options), options },
];

export const getGlobalListingsQueryKey = ({ filters, options }: { filters: SearchListingsFilters; options: SearchListingsOptions }) => [
  GLOBAL_LISTINGS_QUERY_KEY,
  { filters: mapSearchListingsFiltersToSearchFilterRequest(filters, options), options },
];

export const getGeoCoordinatesQueryKey = ({ filters, options }: { filters: SearchListingsFilters; options: SearchListingsOptions }) => [
  GEO_COORDINATES_QUERY_KEY,
  { filters: mapSearchListingsFiltersToSearchFilterRequest(filters, options), options },
];

export const getPlaceDetailsQueryKey = ({ placeId, language }: { placeId?: string; language: Language }) => [
  PLACE_DETAILS_QUERY_KEY,
  placeId,
  language,
];

export const getAgentProfileQueryKey = ({ agentId }: { agentId?: string }) => [AGENT_PROFILE_QUERY_KEY, agentId];

export const getShopQueryKey = ({ shopId }: { shopId?: string }) => [SHOP_QUERY_KEY, shopId];

export const getShopsQueryKey = ({ shopIds }: { shopIds: string[] }) => [SHOPS_QUERY_KEY, [...shopIds].sort()];

export const getWatchlistQueryKey = () => [WATCHLIST_QUERY_KEY];

export const getAutosuggestionQueryKey = (text: string): QueryKey => [AUTOSUGGESTION_QUERY_KEY, text];
